import React from "react";
import Slider from "react-slick";
import { ArrowRight } from "lucide-react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const AboutSection: React.FC = () => {
  const images = [
    "/images/1.jpeg",
    "/images/b-1.jpeg",
    "/images/b-11.jpeg",
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
  };

  return (
    <section className="relative py-20 bg-white dark:bg-gray-900 overflow-hidden">
      
      {/* Background */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="/images/10.jpeg"
          alt="Background"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Title */}
      <h3 className="relative z-10 text-center text-3xl md:text-5xl font-extrabold text-gray-900 dark:text-white mb-6">
        ABOUT US
      </h3>

      <p className="relative z-10 max-w-3xl mx-auto text-center text-gray-600 dark:text-gray-400 text-base md:text-lg leading-relaxed mb-12">
        Braj Decor And Designers, Varanasi is a trusted name in
        <span className="font-semibold text-yellow-600">
          {" "}architectural design & interior solutions
        </span>
        , delivering elegant residential and commercial spaces with modern aesthetics and smart functionality.
      </p>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

        {/* Left Content */}
        <div className="z-10">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white leading-snug">
            Design Your Dream Space with Best{" "}
            <span className="text-yellow-500">
              Architecture & Interior Services
            </span>{" "}
            in Varanasi
          </h2>

          <p className="mt-4 text-gray-600 dark:text-gray-400 leading-relaxed">
            Welcome to <strong>Braj Decor And Designers Varanasi</strong>, where creativity meets functionality. 
            We transform ideas into beautifully planned interiors with premium quality materials and flawless execution.
          </p>

          <p className="mt-4 text-gray-600 dark:text-gray-400 leading-relaxed">
            Our expertise includes residential design, commercial planning, interior design, 
            3D elevation, modular kitchens, custom kitchen layouts, smart storage solutions, 
            and complete turnkey interior execution.
          </p>

          {/* Services List */}
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 text-gray-600 dark:text-gray-400 text-sm">
            <ul className="space-y-2">
              <li>• PVC & 3D Wall Panels</li>
              <li>• Wooden Wall Cladding</li>
              <li>• POP & False Ceiling</li>
              <li>• CNC / MDF Jali Work</li>
              <li>• Wall Molding & Beading</li>
              <li>• Royal Interior Painting</li>
              <li>• Exterior Texture & Wallpaper</li>
            </ul>

            <ul className="space-y-2">
              <li>• Modular Kitchen</li>
              <li>• Wardrobe & Sliding Wardrobe</li>
              <li>• TV Unit & Crockery Unit</li>
              <li>• Bed, Dressing & Side Units</li>
              <li>• Study Table & Office Setup</li>
              <li>• Wooden & Laminated Doors</li>
              <li>• UPVC / Aluminium Windows & Glass Work</li>
            </ul>
          </div>

          {/* Luxury Kitchen Section */}
          <p className="mt-6 text-gray-600 dark:text-gray-400 leading-relaxed">
            We specialize in designing <span className="text-yellow-600 font-semibold">
            luxury modular kitchens</span> that combine elegance, innovation, and functionality. 
            Our kitchens feature premium finishes, soft-close hardware, smart storage solutions, 
            and customized layouts tailored to your lifestyle.
          </p>

          <button className="mt-6 inline-flex items-center px-6 py-3 rounded-full bg-yellow-500 text-white font-medium shadow-lg hover:bg-yellow-600 transition">
            Learn More
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </div>

        {/* Right Slider */}
        <div className="relative z-10 rounded-xl shadow-2xl overflow-hidden">
          <Slider {...settings}>
            {images.map((img, index) => (
              <div key={index}>
                <img
                  src={img}
                  alt={`Slide ${index + 1}`}
                  className="w-full h-[350px] sm:h-[400px] md:h-[500px] object-cover rounded-xl"
                />
              </div>
            ))}
          </Slider>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;